export const services = [
  {
    id: 1,
    title: "Dolby Atmos Theatre",
    description: "Experience true 3D audio with Dolby Atmos technology. Overhead and surround speakers create an immersive soundscape that puts you in the center of the action.",
    image: "https://images.unsplash.com/photo-1635788798247-92a15f830a3b?w=800",
    icon: "Film",
    features: ["5.1.2 / 7.1.4 Setup", "Overhead Speakers", "Premium AVR", "Calibration Included"]
  },
  {
    id: 2,
    title: "4K/8K Projection Systems",
    description: "Crystal clear visuals with the latest 4K and 8K laser projectors. Enjoy cinema-quality picture with vibrant colors and deep blacks on screens up to 200 inches.",
    image: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=800",
    icon: "Monitor",
    features: ["4K/8K Resolution", "Laser Technology", "HDR Support", "200\" Screens"]
  },
  {
    id: 3,
    title: "Acoustic Design & Treatment",
    description: "Professional acoustic engineering with multi-layer soundproofing, bass traps, and diffusers. Eliminate echoes and optimize sound for the perfect listening experience.",
    image: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=800",
    icon: "Waves",
    features: ["Soundproofing", "Bass Traps", "Acoustic Panels", "Room Analysis"]
  },
  {
    id: 4,
    title: "Luxury Theatre Seating",
    description: "Premium recliners with heating, massage, and USB charging. Genuine leather upholstery with motorized adjustments for the ultimate comfort during movie marathons.",
    image: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=800",
    icon: "Armchair",
    features: ["Power Recliners", "Massage Function", "Heated Seats", "USB Charging"]
  },
  {
    id: 5,
    title: "Smart Lighting Control",
    description: "Automated cinema lighting that dims as the movie starts. LED strips, starlight ceilings, and sconce lighting controlled via remote or app for the perfect ambiance.",
    image: "https://images.unsplash.com/photo-1606170033648-5d55a3edf314?w=800",
    icon: "Lightbulb",
    features: ["Auto Dimming", "LED Strips", "Starlight Ceiling", "App Control"]
  },
  {
    id: 6,
    title: "Theatre Room Design",
    description: "Complete interior design service including wall paneling, carpet, step lighting, and themed decor. Transform any room into a stunning private cinema.",
    image: "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?w=800",
    icon: "PaintBucket",
    features: ["Custom Interiors", "Wall Paneling", "Theme Design", "Step Lighting"]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Theatre Specialists",
    description: "We exclusively focus on home theatre design and installation. Our team has decades of combined experience creating cinema-perfect environments.",
    icon: "Star"
  },
  {
    id: 2,
    title: "Turnkey Solutions",
    description: "From initial design to final calibration, we handle everything. Acoustic design, equipment selection, installation, and training—all under one roof.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Premium Brands Only",
    description: "We work exclusively with top-tier brands like Sony, JBL, Klipsch, Denon, and Epson. No compromises on quality, ever.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Custom Acoustic Design",
    description: "Every room is unique. We perform detailed acoustic analysis and create custom treatment plans for optimal sound quality tailored to your space.",
    icon: "Waves"
  },
  {
    id: 5,
    title: "Lifetime Support",
    description: "We provide lifetime technical support, calibration services, and system upgrades. Your theatre evolves with technology, and so do we.",
    icon: "HeadphonesIcon"
  },
  {
    id: 6,
    title: "Certified Technicians",
    description: "Our installation team holds certifications from Dolby, THX, and major equipment manufacturers. Expert installation guaranteed.",
    icon: "BadgeCheck"
  }
];

export const pricingPackages = [
  {
    id: 1,
    name: "Essential Package",
    description: "Perfect entry into cinema-quality entertainment",
    price: "2,29,000",
    popular: false,
    features: [
      "Includes Speakers & Subwoofer",
      "AVR & Upscaling 4k Projector",
      "Cables & Projector Mount, HDMI"
    ]
  },
  {
    id: 2,
    name: "Budget Package",
    description: "High-end speakers with acoustic treatment",
    price: "6,99,000",
    popular: false,
    features: [
      "Includes High End Speakers",
      "Basic Acoustic ( Wall Paneling )",
      "5 Years Warranty on Speaker"
    ]
  },
  {
    id: 3,
    name: "Silver Package",
    description: "Dolby Atmos with complete acoustic setup",
    price: "9,99,000",
    popular: true,
    features: [
      "5.1.2 Dolby Atmos System",
      "4k Projector with Edge Less Screen",
      "4 Layer Acoustics including Recliners"
    ]
  },
  {
    id: 4,
    name: "Gold Package",
    description: "The pinnacle of home cinema luxury",
    price: "12,39,000",
    popular: false,
    features: [
      "7.1.2 Dolby Atmos System",
      "300 Watts Premium Speakers",
      "6 Layers Acoustic treatment with Recliners"
    ]
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Free Consultation & Assessment",
    description: "Start your journey with a free consultation and expert guidance. We understand your vision, space requirements, budget, and technical needs."
  },
  {
    id: 2,
    title: "Custom Design & Proposal",
    description: "We create a custom cinema design with 3D visualization, transparent pricing, and detailed technical proposals. What you see is what you pay."
  },
  {
    id: 3,
    title: "Approval & Scheduling",
    description: "After approval, we schedule installation with a dedicated project manager to ensure smooth execution and minimal disruption."
  },
  {
    id: 4,
    title: "Professional Installation",
    description: "Certified technicians install your cinema with precision, quality workmanship, and complete project manager support throughout."
  },
  {
    id: 5,
    title: "Training & Lifetime Support",
    description: "We provide comprehensive training, documentation, app access, and 24/7 support—your lifetime technology partner."
  }
];

export const projects = [
  {
    id: 1,
    name: "Prestige Golfshire Villa",
    category: "Dolby Atmos",
    description: "Luxury home theatre with 7.1.4 Dolby Atmos and custom acoustic design",
    image: "https://images.unsplash.com/photo-1710131459450-7c384b8be18f?w=800"
  },
  {
    id: 2,
    name: "Sobha Dream Acres",
    category: "4K Projection",
    description: "Premium 4K laser projection with 150-inch motorized screen",
    image: "https://images.unsplash.com/photo-1635788798247-92a15f830a3b?w=800"
  },
  {
    id: 3,
    name: "Brigade Orchards",
    category: "Acoustic Design",
    description: "Complete acoustic treatment with 6-layer soundproofing",
    image: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=800"
  },
  {
    id: 4,
    name: "Embassy Springs",
    category: "Luxury Seating",
    description: "Premium cinema with leather recliners and bar counter",
    image: "https://images.unsplash.com/flagged/photo-1572609239482-d3a83f976aa0?w=800"
  },
  {
    id: 5,
    name: "Godrej Park Retreat",
    category: "Theme Design",
    description: "Hollywood-themed cinema with custom wall art and lighting",
    image: "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?w=800"
  },
  {
    id: 6,
    name: "Adarsh Palm Retreat",
    category: "Dolby Atmos",
    description: "Integrated 5.1.2 Dolby Atmos with smart lighting control",
    image: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=800"
  },
  {
    id: 7,
    name: "Salarpuria Sattva",
    category: "Starlight Ceiling",
    description: "Dolby Atmos cinema with fiber optic starlight ceiling",
    image: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=800"
  },
  {
    id: 8,
    name: "Mantri Developers",
    category: "Commercial",
    description: "Professional screening room for corporate office",
    image: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=800"
  },
  {
    id: 9,
    name: "DLF New Town Heights",
    category: "8K Projection",
    description: "Ultra-premium 8K laser projector with 200-inch screen",
    image: "https://images.unsplash.com/photo-1710131459450-7c384b8be18f?w=800"
  },
  {
    id: 10,
    name: "Shriram Chirping Woods",
    category: "Luxury Seating",
    description: "Complete theatre with massage recliners and mini-bar",
    image: "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?w=800"
  },
  {
    id: 11,
    name: "Total Environment",
    category: "Acoustic Design",
    description: "Minimalist cinema design with premium acoustics",
    image: "https://images.unsplash.com/photo-1635788798247-92a15f830a3b?w=800"
  },
  {
    id: 12,
    name: "Century Real Estate",
    category: "Theme Design",
    description: "Art deco themed theatre with vintage movie posters",
    image: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=800"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Arjun Reddy",
    location: "Bangalore",
    service: "Dolby Atmos Installation",
    review: "Pro Cinemax transformed our basement into an incredible cinema! The Dolby Atmos sound is absolutely mind-blowing. Every movie feels like a theatrical experience. Best investment we've made!",
    avatar: "A"
  },
  {
    id: 2,
    name: "Meera Krishnan",
    location: "Bangalore",
    service: "Complete Theatre Setup",
    review: "From acoustics to seating, everything was handled professionally. The attention to detail is remarkable. Our family movie nights have never been better!",
    avatar: "M"
  },
  {
    id: 3,
    name: "Vikram Malhotra",
    location: "Bangalore",
    service: "4K Projection System",
    review: "The 4K laser projector they installed is stunning. Picture quality rivals any multiplex. Their team was knowledgeable and the installation was flawless.",
    avatar: "V"
  },
  {
    id: 4,
    name: "Priya Sharma",
    location: "Bangalore",
    service: "Acoustic Treatment",
    review: "The acoustic treatment made a world of difference. Sound quality is crystal clear with no echoes. Pro Cinemax really knows their craft!",
    avatar: "P"
  },
  {
    id: 5,
    name: "Rajesh Nair",
    location: "Bangalore",
    service: "Luxury Theatre Room",
    review: "The team designed a stunning Avengers-themed theatre for my kids. Premium recliners, star ceiling, and incredible surround sound. Pro Cinemax exceeded all expectations!",
    avatar: "R"
  },
  {
    id: 6,
    name: "Sneha Gupta",
    location: "Bangalore",
    service: "Home Cinema Consultation",
    review: "Professional from start to finish. They helped us understand every option and delivered exactly what we envisioned. The ambient lighting and acoustics are perfect!",
    avatar: "S"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How much space do I need for a home theatre?",
    answer: "A dedicated home theatre can be created in spaces as small as 10x12 feet, though 12x15 feet or larger is ideal. We can work with your available space and design an optimized layout for the best experience."
  },
  {
    id: 2,
    question: "What's the difference between 5.1, 7.1, and Dolby Atmos?",
    answer: "5.1 has five speakers plus subwoofer (surround sound). 7.1 adds two more rear speakers for enhanced immersion. Dolby Atmos adds overhead speakers (e.g., 5.1.2 or 7.1.4) for true 3D audio with sound from all directions including above."
  },
  {
    id: 3,
    question: "How long does installation take?",
    answer: "A basic home theatre setup takes 3-5 days. Complex installations with full acoustic treatment, custom carpentry, and starlight ceilings may require 1-2 weeks. We'll provide a detailed timeline during consultation."
  },
  {
    id: 4,
    question: "Do you provide maintenance and support?",
    answer: "Yes! We provide lifetime technical support including system health checks, calibration services, software updates, and equipment troubleshooting. Our 24/7 helpline ensures you're never without assistance."
  },
  {
    id: 5,
    question: "Can you work with my existing room?",
    answer: "Absolutely! We specialize in retrofit installations. We can transform any existing room—basement, spare bedroom, or living room—into a dedicated cinema without major structural changes."
  },
  {
    id: 6,
    question: "What brands do you work with?",
    answer: "We work exclusively with premium brands including Sony, Epson, JBL, Klipsch, Denon, Yamaha, Marantz, and more. We select the best equipment for your budget and requirements."
  }
];
